import * as React from "react";
import { SVGProps, memo } from "react";
const SvgCertifiedBase12Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.732 5.225a1.258 1.258 0 0 0-.839-2.023 1.26 1.26 0 0 1-1.095-1.096 1.258 1.258 0 0 0-2.024-.838 1.254 1.254 0 0 1-1.548 0 1.258 1.258 0 0 0-2.024.838 1.26 1.26 0 0 1-1.095 1.096 1.258 1.258 0 0 0-.839 2.023 1.259 1.259 0 0 1 0 1.55 1.259 1.259 0 0 0 .839 2.023c.573.07 1.024.522 1.095 1.096a1.258 1.258 0 0 0 2.024.838 1.256 1.256 0 0 1 1.548 0 1.258 1.258 0 0 0 2.024-.838 1.258 1.258 0 0 1 1.095-1.096 1.259 1.259 0 0 0 .839-2.023 1.259 1.259 0 0 1 0-1.55Z"
      fill="#008057"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.206 3.564 8 4 5.998 8.428a.45.45 0 0 1-.132.147l-.072.042-.017.007a.455.455 0 0 1-.506-.084L3.369 6.647 4 6l1.483 1.493 1.723-3.929Z"
      fill="#FAFAFA"
    />
  </svg>
);
const Memo = memo(SvgCertifiedBase12Px);
export default Memo;
